import React, { useState } from 'react';
import Modal from '../UI/Modal';
import Button from '../UI/Button';

export default function DeleteConfirmModal({ isOpen, onClose, onConfirm, resumeTitle }) {
	const [text, setText] = useState('');
	const canDelete = text === 'DELETE';
	return (
		<Modal isOpen={isOpen} onClose={onClose} title="Delete Resume">
			<p className="text-sm text-gray-700">
				Are you sure you want to delete <strong>{resumeTitle}</strong>? This action cannot be undone. Type "DELETE" to confirm.
			</p>
			<input className="mt-2 w-full border rounded px-3 py-2" value={text} onChange={(e) => setText(e.target.value)} placeholder='Type "DELETE" to confirm' />
			<div className="mt-3 flex justify-end gap-2">
				<Button variant="ghost" onClick={onClose}>
					Cancel
				</Button>
				<Button variant="danger" disabled={!canDelete} onClick={onConfirm}>
					Delete
				</Button>
			</div>
		</Modal>
	);
}


